<form [formGroup]="form" class="ndis-classification-step">
  <p class="ndis-classification-hint">{{ hintText }}</p>
  <app-chip-group
    [control]="form.controls.supportPurpose"
    [options]="supportPurposeOptions"
    [label]="supportPurposeLabel"
  />
  <app-chip-group
    [control]="form.controls.supportCategory"
    [options]="supportCategoryOptions"
    [label]="supportCategoryLabel"
  />
  <app-chip-group
    [control]="form.controls.registrationGroups"
    [options]="registrationGroupsOptions"
    [label]="registrationGroupsLabel"
  />
</form>
